import { Routes, Route } from "react-router-dom";
import { Suspense } from "react";

import HomeP from "./pages/Home";
import Certificates from "./pages/Certificates";
import Reviews from "./pages/Reviews";
import CV from "./pages/CV";

export const RouterApp = () => {
  return (
    <Suspense fallback={""}>
      <Routes>
        <Route index element={<HomeP />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/cv" element={<CV />} />
      </Routes>
    </Suspense>
  );
};
